jQuery(function ($) {
  /* Product page: keep the gallery in sync with the selected hardware variant,
     and open on the right photo when arriving with ?variant=ID (e.g. from a collection card). */

  function fileKey(src) {
    if (!src) {
      return '';
    }
    var s = String(src).split('?')[0];
    s = s.substring(s.lastIndexOf('/') + 1);
    return s.replace(/\.[a-z0-9]+$/i, '');
  }

  function goToSlideForImage(image) {
    var $slider = $('.vertical-slider-for');
    if (!$slider.length || !$slider.hasClass('slick-initialized') || !image) {
      return;
    }
    var $slides = $slider.find('.slick-slide:not(.slick-cloned)');
    var $target = $();

    if (image.id) {
      $target = $slides.filter('[data-image-id="' + image.id + '"]').first();
    }
    if (!$target.length && image.src) {
      var key = fileKey(image.src);
      if (key) {
        $target = $slides
          .filter(function () {
            var $img = $(this).find('img').first();
            var src = $img.attr('data-src') || $img.attr('src') || '';
            return src.indexOf(key) !== -1;
          })
          .first();
      }
    }
    if (!$target.length) {
      return;
    }
    var slideIndex = parseInt($target.attr('data-slick-index'), 10);
    if (!isNaN(slideIndex)) {
      $slider.slick('slickGoTo', slideIndex);
    }
  }

  function getProductJson() {
    var $json = $('[id^="ProductJson-"]').first();
    if (!$json.length) {
      return null;
    }
    try {
      return JSON.parse($json.html());
    } catch (e) {
      return null;
    }
  }

  function findMatchingVariant(product, $form) {
    var selected = [];
    $form.find('.swatch[data-option-index]').each(function () {
      var idx = parseInt($(this).attr('data-option-index'), 10);
      var val = $(this).find(':radio:checked').val();
      selected[idx] = val;
    });
    if (!selected.length) {
      return null;
    }
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var matches = true;
      for (var j = 0; j < selected.length; j++) {
        if (selected[j] !== undefined && v.options[j] !== selected[j]) {
          matches = false;
          break;
        }
      }
      if (matches) {
        return v;
      }
    }
    return null;
  }

  $(document).on('change', '.swatch :radio', function () {
    var $form = $(this).closest('form');
    var product = getProductJson();
    if (!product) {
      return;
    }
    var variant = findMatchingVariant(product, $form);
    if (variant && variant.featured_image) {
      goToSlideForImage(variant.featured_image);
    }
  });

  (function applyVariantFromUrl() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (!m) {
      return;
    }
    var product = getProductJson();
    if (!product) {
      return;
    }
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (String(v.id) === m[1]) {
        for (var k = 0; k < v.options.length; k++) {
          $('.swatch[data-option-index="' + k + '"] :radio')
            .filter(function () {
              return this.value === v.options[k];
            })
            .prop('checked', true);
        }
        if (v.featured_image) {
          goToSlideForImage(v.featured_image);
        }
        return;
      }
    }
  })();

  window.hardwareSwatchGoToSlideForImage = goToSlideForImage;
});
